import 'floating-vue/dist/style.css'
import FloatingVue from 'floating-vue'

function initFloatingVue(app) {
  app.use(FloatingVue, {
    themes: {
      dropdown: {
        overflowPadding: 8, // garde 8px avec les bords de l’écran
      },
      'tooltip-dark': {
        $extend: 'dropdown',
      },
      'tooltip-light': {
        $extend: 'tooltip-dark',
      },
      'tooltip-orange': {
        $extend: 'tooltip-light',
      },
      'tooltip-light-datepicker': {
        $extend: 'tooltip-light',
      },
      'tooltip-light-large': {
        $extend: 'tooltip-light',
      },
    },
  })
}
export default initFloatingVue
